var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,4L1,4C0.448,4 0,4.448 0,5C-0,5.552 0.448,6 1,6L2,6L2,19C2,19.796 2.316,20.559 2.879,21.121C3.441,21.684 4.204,22 5,22C5,22 15,22 15,22C15.796,22 16.559,21.684 17.121,21.121C17.684,20.559 18,19.796 18,19L18,6L19,6C19.552,6 20,5.552 20,5C20,4.448 19.552,4 19,4L15,4L15,3C15,2.204 14.684,1.441 14.121,0.879C13.559,0.316 12.796,0 12,0C12,0 8,0 8,0C7.204,0 6.441,0.316 5.879,0.879C5.316,1.441 5,2.204 5,3L5,4ZM16,6L16,19C16,19.265 15.895,19.52 15.707,19.707C15.52,19.895 15.265,20 15,20L5,20C4.735,20 4.48,19.895 4.293,19.707C4.105,19.52 4,19.265 4,19L4,6L16,6ZM11,10L11,16C11,16.552 11.448,17 12,17C12.552,17 13,16.552 13,16L13,10C13,9.448 12.552,9 12,9C11.448,9 11,9.448 11,10ZM7,10L7,16C7,16.552 7.448,17 8,17C8.552,17 9,16.552 9,16L9,10C9,9.448 8.552,9 8,9C7.448,9 7,9.448 7,10ZM13,4L13,3C13,2.735 12.895,2.48 12.707,2.293C12.52,2.105 12.265,2 12,2L8,2C7.735,2 7.48,2.105 7.293,2.293C7.105,2.48 7,2.735 7,3L7,4L13,4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.21cf3ee38e3593b76c4a4b521f7bc8a8.svg";
export { ForwardRef as ReactComponent };